import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Admin from "layouts/Admin.js";
import Login from "./views/Login/login";
import Perfil from "./views/Inicio/componentes/perfil";
import "assets/css/material-dashboard-react.css?v=1.9.0";

import { AuthProvider } from "./contexts/AuthContext"; // 👈 importa tu provider

ReactDOM.render(
  <AuthProvider> {/* 👈 envolvemos TODO dentro del provider */}
    <Router>
      <Switch>
        {/* Ruta independiente para el login */}
        <Route exact path="/login" component={Login} />

        {/* Ruta para el perfil */}
        <Route exact path="/perfil" component={Perfil} />

        {/* Ruta general para Admin */}
        <Route path="/admin" component={Admin} />

        {/* Redirección desde "/" hacia /login solo si no estás en /perfil */}
        <Redirect from="/" to="/login" />
      </Switch>
    </Router>
  </AuthProvider>,
  document.getElementById("root")
);
